const CREATE_ANALYSE_RESPONSE = {
  Result: 'Result',
  TokenError: 'TokenError',
  WrongInputs: 'WrongInputs',
  Unauthorized: 'Unauthorized',
};

export default CREATE_ANALYSE_RESPONSE;
